/*
file: 内容单列摘要模块
*/
import {FC, useCallback, useState, useEffect, useRef} from 'react';
import {getTopicItemlist, TopicModule, ItemQuery} from '@/services/pages/channel/channel.client';
import {useSearchParams} from '@/hooks/router';
import {VALUE_TYPE} from '@/dicts/consts';
import ArticleCard from '../articleCard';
import Title from '../title';
import styles from './index.less';

interface CardProps {
    page: string;
    sfRef?: string;
    channelBusinessLine?: string;
    infos: TopicModule;
}
// eslint-disable-next-line complexity
const SelfTopicContentSingleAbstract: FC<CardProps> = ({
    infos, page, channelBusinessLine,
}) => {
    const openSize = infos?.moduleOpenRows ?? 5;

    const [module, setModule] = useState<TopicModule>();
    const [itemQuery, setItemQuery] = useState<ItemQuery>({pageSize: 10, pageNo: 1});
    const [size, setSize] = useState<number>(0);
    const sizeRef = useRef<number>(0);
    const param = useSearchParams();

    useEffect(
        () => {
            setModule(infos);
            const size = infos.moduleMaxRows || infos.itemList?.length || 0;
            const maxSize = size < (infos.itemList?.length || 0) ? size : (infos.itemList?.length || 0);

            // eslint-disable-next-line no-unused-expressions
            sizeRef.current === 0 ? setSize(maxSize) : null;
            // eslint-disable-next-line no-unused-expressions
            sizeRef.current === 0 ? sizeRef.current = maxSize : null;
            setItemQuery({
                id: param.id,
                // eslint-disable-next-line camelcase
                sf_ch: param.sf_ch,
                moduleId: infos.moduleId,
                preview: param.preview,
                pageSize: 10,
                pageNo: 1,
            });
        },
        [infos, param.id, param.preview, param.sf_ch]
    );

    const loadMore = useCallback(
        () => {
            const query = {
                // eslint-disable-next-line camelcase
                sf_ch: itemQuery?.sf_ch,
                id: param.id,
                pageNo: ++itemQuery.pageNo,
                pageSize: itemQuery.pageSize,
                moduleId: infos.moduleId,
            };
            setItemQuery(query);
        },
        []
    );

    const handleMoreClick = useCallback(
        currentModule => {
            const dataSize = currentModule.itemList?.length || 0;
            const nextMaxShowSize = sizeRef.current + openSize;
            const value = dataSize > nextMaxShowSize ? nextMaxShowSize : dataSize;

            // eslint-disable-next-line no-unused-expressions
            !(dataSize < currentModule.count && dataSize === size)
                ? setSize(value)
                : null;

            // eslint-disable-next-line no-unused-expressions
            dataSize < currentModule.count && dataSize === sizeRef.current
                ? loadMore()
                : sizeRef.current = value;
        },
        [loadMore, openSize, size]
    );

    // eslint-disable-next-line complexity
    const fetchItemList = async (
        id?: string, moduleId?: number, pageSize?: number,
        // eslint-disable-next-line camelcase
        pageNo?: number, sf_ch?: string, preview?: boolean
    ) => {
        if (!id || !moduleId) {
            return;
        }
        try {
            const data = await getTopicItemlist({
                id: id,
                moduleId: moduleId,
                pageSize: pageSize || 10,
                pageNo: pageNo || 1,
                // eslint-disable-next-line camelcase
                sf_ch: sf_ch,
                preview: preview,
            });

            const list = [];
            if (module?.itemList && Array.isArray(module?.itemList)) {
                list.push(...module.itemList);
            }
            if (data && Array.isArray(data.list)) {
                list.push(...data.list);
            }

            const appendModule = {
                moduleId: module?.moduleId,
                channelId: module?.channelId,
                moduleName: module?.moduleName,
                isShowTitle: module?.isShowTitle,
                moduleMaxRows: module?.moduleMaxRows,
                moduleEnName: module?.moduleEnName,
                moduleSubTitle: module?.moduleSubTitle,
                moduleMaxColumns: module?.moduleMaxColumns,
                moduleType: module?.moduleType,
                moduleStyle: module?.moduleStyle,
                count: data.count || module?.itemList?.length,
                moreUrl: module?.moreUrl,
                itemList: pageNo === 1 ? module?.itemList : list,
            };

            setModule(appendModule);

            pageNo !== 1 ? handleMoreClick(appendModule) : null;

        } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
        }
    };

    useEffect(
        () => {
            fetchItemList(
                itemQuery.id,
                itemQuery.moduleId,
                itemQuery.pageSize,
                itemQuery.pageNo,
                itemQuery?.sf_ch,
                itemQuery.preview
            );
        },
        [itemQuery]
    );

    return (
        <div
            data-show={
                JSON.stringify({
                    'page': page,
                    'value': 'jump_neirong_danliezhaiyao',
                    'pageSourceId': infos.channelId,
                    'pageType': channelBusinessLine,
                    'valueId': infos.moduleId,
                    'valueTitle': infos.moduleName,
                    'valueType': VALUE_TYPE.MODULE,
                })
            }
        >
            {
                infos.isShowTitle === 1 && (infos.moduleName || infos.moduleSubTitle)
                && <Title
                    title={infos.moduleName ?? ''}
                    subTitle={infos.moduleSubTitle ?? ''}
                    moreLink={infos.moreUrl ?? ''}
                    className={styles.title}
                />
            }
            {
                module?.itemList?.map((item, index) => {
                    return (
                        <div
                            className={styles.cardWrap}
                            key={item.itemId}
                            data-show={JSON.stringify({
                                'page': page,
                                'value': 'jump_neirong_danliezhaiyao',
                                'pageSourceId': infos.channelId,
                                'pageType': channelBusinessLine,
                                'valueId': item.itemId,
                                'valueTitle': item.title,
                                'valueType': VALUE_TYPE.ITEM,
                            })}
                        >
                            {
                                index < size
                                    ? (
                                        <>
                                            <ArticleCard
                                                specInfo={item.fieldValue}
                                                ubcExt={{
                                                    page: page,
                                                    value: 'jump_neirong_danliezhaiyao',
                                                    pageSourceId: item.channelId,
                                                    pageType: channelBusinessLine ?? '',
                                                    valueId: item.itemId,
                                                    valueTitle: item.title ?? '',
                                                }}
                                            />
                                            {
                                                index < (module?.count || 1) - 1
                                                    ? <div className={styles.line} />
                                                    : null
                                            }
                                        </>
                                    )
                                    : null
                            }
                        </div>
                    );
                })}
            {
                // eslint-disable-next-line max-len
                (module?.itemList && ((module?.itemList.length || 0) > size && size > 0 || module?.itemList.length < (module?.count || 0)))
                    ? (
                        <div
                            className={styles.moreTextWrap}
                            onClick={() => {
                                handleMoreClick(module);
                            }}
                        >

                            <span
                                className={styles.moreText}
                            >
                                展开更多
                            </span>

                            <img
                                src={'https://med-fe.cdn.bcebos.com/content-external-channel/more-down.png'}
                                className={styles.arrow}
                            />
                        </div>
                    )
                    : null
            }
        </div>
    );
};
export default SelfTopicContentSingleAbstract;
